document.addEventListener('DOMContentLoaded', () => {

    /* =====================================================
     * ELEMENTY
     * ===================================================== */

    const modal = document.querySelector('.cookie-consent');
    const accordion = document.querySelector('.cookie-consent__accordion');

    const functionalCookiesCheckbox =
        document.querySelector('input[name="functional-cookies"]');
    const analyticalCookiesCheckbox =
        document.querySelector('input[name="analytical-cookies"]');
    const marketingCookiesCheckbox =
        document.querySelector('input[name="marketing-cookies"]');

    let lastFocus = null;


    /* =====================================================
     * INIT LOCAL STORAGE
     * ===================================================== */

    if (localStorage.getItem('necessaryCookies') === null) {
        localStorage.setItem('consentGranted', 'false');
    }

    initialize();


    /* =====================================================
     * EVENTS
     * ===================================================== */

    document.querySelectorAll('.customize-cookie').forEach(btn => {
        btn.addEventListener('click', () => slideToggle(accordion));
    });

    document.querySelector('.accept-all-cookie')
        ?.addEventListener('click', () => {
            slideToggle(accordion);
            saveSettings(true, true, true, true);
            hideModalCookie();
        });

    document.querySelector('.btn-save-choice')
        ?.addEventListener('click', () => {
            slideToggle(accordion);

            saveSettings(
                true,
                functionalCookiesCheckbox.checked,
                analyticalCookiesCheckbox.checked,
                marketingCookiesCheckbox.checked
            );

            hideModalCookie();
        });

    document.querySelectorAll('.customize-cookies').forEach(btn => {
        btn.setAttribute('role', 'button');
        btn.setAttribute('aria-haspopup', 'dialog');

        btn.addEventListener('click', e => {
            e.preventDefault();
            updateModalSettings();
            showModalCookie();
        });
    });


    /* =====================================================
     * MODAL OPEN / CLOSE (ZGODNE Z TWOIM SYSTEMEM)
     * ===================================================== */

    function showModalCookie() {
        lastFocus = document.activeElement;

        modal.hidden = false;
        document.body.classList.add('is-locked');

        const focusable = getFocusables();
        (focusable[0] || modal).focus({ preventScroll: true });
    }

    function hideModalCookie() {
        modal.hidden = true;
        document.body.classList.remove('is-locked');

        if (lastFocus) {
            lastFocus.focus({ preventScroll: true });
        }
    }

    function getFocusables() {
        return modal.querySelectorAll(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
    }


    /* =====================================================
     * SLIDE TOGGLE (ZAMIENNIK jQuery)
     * ===================================================== */

    function slideToggle(el, duration = 280) {
        if (!el) return;

        el.style.overflow = 'hidden';
        el.style.transition = `height ${duration}ms`;

        if (el.hidden || el.offsetHeight === 0) {
            el.hidden = false;
            const height = el.scrollHeight;
            el.style.height = '0px';

            requestAnimationFrame(() => {
                el.style.height = height + 'px';
            });

            setTimeout(() => {
                el.style.height = '';
                el.style.transition = '';
                el.style.overflow = '';
            }, duration);

        } else {
            el.style.height = el.offsetHeight + 'px';

            requestAnimationFrame(() => {
                el.style.height = '0px';
            });

            setTimeout(() => {
                el.hidden = true;
                el.style.height = '';
                el.style.transition = '';
                el.style.overflow = '';
            }, duration);
        }
    }


    /* =====================================================
     * LOGIKA COOKIES
     * ===================================================== */

    function initialize() {
        if (localStorage.getItem('consentGranted') === 'false') {
            showModalCookie();
        } else {
            saveSettings(
                true,
                localStorage.getItem('functionalCookies') === 'true',
                localStorage.getItem('analyticalCookies') === 'true',
                localStorage.getItem('marketingCookies') === 'true'
            );
        }

        updateModalSettings();
    }

    function updateModalSettings() {
        if (localStorage.getItem('consentGranted') === 'true') {
            functionalCookiesCheckbox.checked =
                localStorage.getItem('functionalCookies') === 'true';

            analyticalCookiesCheckbox.checked =
                localStorage.getItem('analyticalCookies') === 'true';

            marketingCookiesCheckbox.checked =
                localStorage.getItem('marketingCookies') === 'true';
        }
    }


    /* =====================================================
     * SAVE + GTM CONSENT MODE
     * ===================================================== */

    function saveSettings(
        necessaryCookies = false,
        functionalCookies = false,
        analyticalCookies = false,
        marketingCookies = false
    ) {
        localStorage.setItem('consentGranted', 'true');
        localStorage.setItem('necessaryCookies', String(necessaryCookies));
        localStorage.setItem('functionalCookies', String(functionalCookies));
        localStorage.setItem('analyticalCookies', String(analyticalCookies));
        localStorage.setItem('marketingCookies', String(marketingCookies));

        window.dataLayer = window.dataLayer || [];

        function gtag() {
            window.dataLayer.push(arguments);
        }

        gtag('consent', 'update', {
            personalization_storage: necessaryCookies ? 'granted' : 'denied',
            security_storage: necessaryCookies ? 'granted' : 'denied',
            functionality_storage: functionalCookies ? 'granted' : 'denied',
            analytics_storage: analyticalCookies ? 'granted' : 'denied',
            ad_storage: marketingCookies ? 'granted' : 'denied',
            ad_user_data: marketingCookies ? 'granted' : 'denied',
            ad_personalization: marketingCookies ? 'granted' : 'denied'
        });

        window.dataLayer.push({ event: 'cookie_consent_update' });
    }
});
